import React from "react";

export const Button = React.forwardRef(function Button(
  { className = "", children, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      className={
        "inline-flex items-center justify-center rounded-xl px-5 py-3 font-semibold text-white " +
        "focus:outline-none focus:ring-2 focus:ring-offset-2 transition " +
        className
      }
      {...props}
    >
      {children}
    </button>
  );
});
